<template>
  <div>
    <div class="inner-content">
      <div class="container">
        <section class="product">
          <h2 class="wow animate fadeInDown">Color your hair the natural way</h2>
          <p class="wow animate fadeInUp">Solutions for quick hair coloring</p>
          <div class="container mt-40">
            <div class="row">
              <div class="col-md-6">
                <div class="outer">
                  <div id="big" class="owl-carousel owl-theme remove-arrow">
                    <div class="item" v-for="(item) in filteredProductList" :key="item.id">
                      <img :src="item.src" alt>
                    </div>
                  </div>
                  <div id="thumbs" class="owl-carousel owl-theme thumb-style">
                    <div class="item" v-for="(item) in filteredProductList" :key="item.id">
                      <img :src="item.src" alt>
                    </div>
                  </div>
                </div>
                <div class="back-to-page">
                  <section class="centered-container">
                    <a
                      class="link link--arrowed"
                      href="#"
                      @click.prevent="$router.push({path:'/products'})"
                    >
                      <svg
                        class="arrow-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                      >
                        <g
                          fill="none"
                          stroke="#cf0021"
                          stroke-width="1.5"
                          stroke-linejoin="round"
                          stroke-miterlimit="10"
                        >
                          <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                          <path
                            class="arrow-icon--arrow"
                            d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"
                          ></path>
                        </g>
                      </svg>Go back to products
                    </a>
                  </section>
                </div>
              </div>
              <div class="col-md-6">
                <div class="produt-head">
                  <h3 class="wow animate fadeInDown">{{productItem.extra_data.display_name}}</h3>
                  <span class="wow animate fadeInDown">{{productItem.extra_data.subtitle}}</span>
                </div>
                <div>
                  <h4 class="produt-detail wow animate fadeInDown">About the Product</h4>
                  <div
                    v-html="productItem.description"
                    class="produt-detail wow animate fadeInDown"
                  ></div>
                </div>
                <div class="packaging-detail">
                  <h4 class="wow animate fadeInDown">Packaging details</h4>
                  <table>
                    <tr class="produt-detail wow animate fadeInDown">
                      <td>Package Size</td>
                      <td>: {{productItem.extra_data.package_size}}</td>
                    </tr>
                    <tr class="produt-detail wow animate fadeInDown">
                      <td>Article Number</td>
                      <td>: {{productItem.extra_data.article_number}}</td>
                    </tr>
                    <tr class="produt-detail wow animate fadeInDown">
                      <td>Barcode</td>
                      <td>: {{productItem.extra_data.barcode}}</td>
                    </tr>
                  </table>
                  <button
                    class="feedback-btn wow animate fadeInDown"
                    data-toggle="modal"
                    data-target="#exampleModal"
                    data-whatever="@mdo"
                  >
                    Send
                    your feedback
                  </button>

                  <div
                    class="modal fade"
                    id="exampleModal"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                  >
                    <div class="modal-dialog model-style" role="document">
                      <div class="modal-content">
                        <div class="modal-body">
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                          <div class="contact-form">
                            <div class="row">
                              <div class="col-md-7">
                                <form id="feedback-form">
                                  <div class="row">
                                    <div class="col-md-6">
                                      <div class="form-group">
                                        <input
                                          placeholder="Name"
                                          type="text"
                                          required
                                          v-model="form.name"
                                        >
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <div class="form-group">
                                        <input
                                          placeholder="Email"
                                          type="email"
                                          required
                                          v-model="form.email"
                                        >
                                      </div>
                                    </div>
                                    <div class="col-md-12">
                                      <div class="form-group">
                                        <input
                                          placeholder="Phone"
                                          type="tel"
                                          required
                                          v-model="form.phone"
                                        >
                                      </div>
                                    </div>

                                    <div class="col-md-12">
                                      <div class="form-group">
                                        <textarea
                                          placeholder="Message"
                                          required
                                          v-model="form.message"
                                        ></textarea>
                                      </div>
                                    </div>
                                    <div class="col-md-12">
                                      <div class="form-group">
                                        <button class="red-btn2" @click="sendFeedBack">Submit</button>
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </div>
                              <div class="col-md-5 feedback-bg">
                                <p>
                                  We'd love to here from you. Fill your information below and we'll respond as soon as
                                  possible
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="related-product" v-if="relatedProductsLoaded">
          <h3 class="wow animate fadeInDown">You might also like</h3>
          <div class="related-product-block">
            <div class="row">
              <div
                class="col-sm-6 col-md-3"
                v-for="item in productItem.related_products"
                :key="item.id"
                @click.prevent="showProduct(item)"
              >
                <a href="#">
                  <div class="r-product">
                    <img :src="item.images[0].src" class="wow animate fadeIn" alt>
                    <h4 class="wow animate fadeInDown">{{item.extra_data.display_name}}</h4>
                    <p class="wow animate fadeInUp">{{item.extra_data.subtitle}}</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <footer2></footer2>
  </div>
</template>

<script>
import Footer2 from "@/components/Footer2.vue";
import { required, minLength, email, sameAs } from "vuelidate/lib/validators";

export default {
  name: "ProductDetails",
  components: {
    Footer2
  },
  computed: {
    filteredProductList() {
      const result = this.productItem.images.filter(
        (item, index) => index != 0
      );
      return result;
    }
  },
  data() {
    return {
      productItem: null,
      relatedProductsLoaded: false,
      form: {
        name: "",
        email: "",
        phone: "",
        message: ""
      }
    };
  },

  created() {
    let receivedProductId = this.$route.params.productId;
    let tempItem = this.$root.products.find(function(item) {
      return item.id == receivedProductId;
    });
    this.productItem = Object.assign({}, tempItem);
    this.loadRelatedProducts();
    /*
    if (!this.productItem.related_products) {
      this.loadRelatedProducts();
    }
    */
  },
  mounted() {
    //this.initOwlCarousel();

    this.$root.initBody();

    //remove all touch events
    var myElement = document.getElementById("app");
    var mc = new Hammer(myElement);
    mc.destroy();

    var bigimage = $("#big");
    var thumbs = $("#thumbs");
    //var totalslides = 10;
    var syncedSecondary = true;

    console.log("bigimage", bigimage);
    bigimage
      .owlCarousel({
        items: 1,
        slideSpeed: 2000,
        nav: true,
        autoplay: false,
        dots: false,
        loop: true,
        responsiveRefreshRate: 200,
        navText: [
          '<i class="fa fa-angle-left" aria-hidden="true"></i>',
          '<i class="fa fa-angle-right" aria-hidden="true"></i>'
        ]
      })
      .on("changed.owl.carousel", syncPosition);

    thumbs
      .on("initialized.owl.carousel", function() {
        thumbs
          .find(".owl-item")
          .eq(0)
          .addClass("current");
      })
      .owlCarousel({
        items: 4,
        dots: true,
        nav: true,
        navText: [
          '<i class="fa fa-angle-left" aria-hidden="true"></i>',
          '<i class="fa fa-angle-right" aria-hidden="true"></i>'
        ],
        smartSpeed: 200,
        slideSpeed: 500,
        slideBy: 4,
        responsiveRefreshRate: 100
      })
      .on("changed.owl.carousel", syncPosition2);

    function syncPosition(el) {
      //if loop is set to false, then you have to uncomment the next line
      //var current = el.item.index;

      //to disable loop, comment this block
      var count = el.item.count - 1;
      var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

      if (current < 0) {
        current = count;
      }
      if (current > count) {
        current = 0;
      }
      //to this
      thumbs
        .find(".owl-item")
        .removeClass("current")
        .eq(current)
        .addClass("current");
      var onscreen = thumbs.find(".owl-item.active").length - 1;
      var start = thumbs
        .find(".owl-item.active")
        .first()
        .index();
      var end = thumbs
        .find(".owl-item.active")
        .last()
        .index();

      if (current > end) {
        thumbs.data("owl.carousel").to(current, 100, true);
      }
      if (current < start) {
        thumbs.data("owl.carousel").to(current - onscreen, 100, true);
      }
    }

    function syncPosition2(el) {
      if (syncedSecondary) {
        var number = el.item.index;
        bigimage.data("owl.carousel").to(number, 100, true);
      }
    }

    thumbs.on("click", ".owl-item", function(e) {
      e.preventDefault();
      var number = $(this).index();
      bigimage.data("owl.carousel").to(number, 300, true);
    });
  },
  methods: {
    sendFeedBack(e, elt2) {
      let me = this;
      var form = document.getElementById("feedback-form");
      var isValidForm = form.checkValidity();
      if (isValidForm) {
        e.preventDefault();
        var settings = {
          async: true,
          crossDomain: true,
          url: me.$root.serverRoute("feedBack"),
          method: "POST",
          dataType: "json",
          data: JSON.stringify(me.form)
        };
        this.$root.loadingQueueSize++;
        $.ajax(settings)
          .done(function(resp) {
            me.$root.loadingQueueSize--;
            //console.log(resp);
            if (resp.success == false) {
              me.$root.msgBox.alertType = "danger";
              me.$root.msgBox.message =
                "An error occurs on the server. <br>" + resp.message;
              $("#main-msg-box").modal();
            } else {
              me.$root.msgBox.alertType = "success";
              me.$root.msgBox.message =
                "Thank you. We received you feedback.<br> We will get back to you soon";
              $("#main-msg-box").modal();

              /*
              me.form = {
                email: ""
              };*/
            }
          })
          .fail(function(resp) {
            me.$root.loadingQueueSize--;
            me.$root.msgBox.alertType = "danger";
            me.$root.msgBox.message =
              "An error occurs on the server 'very big error'";
            $("#main-msg-box").modal();
          });
      }
    },
    showProduct(item) {
      this.$router.push({
        name: "product-details",
        params: { productId: item.id }
      });
      location.reload();
      //location = this.$root.siteRoot() + "/#product-details/" + item.id + "#";
    },
    cleanProductList() {},
    saveFeedback() {
      console.log("test");
    },
    loadRelatedProductsStatic() {
      //this.productItem.extra_data.related_products
      let tempItem = this.$root.products.find(function(item) {
        return item.id == receivedProductId;
      });
    },
    loadRelatedProducts() {
      let me = this;
      var settings = {
        async: true,
        crossDomain: true,
        url: me.$root.serverRoute("relatedProductsDetails"),
        method: "POST",
        dataType: "json",
        data: JSON.stringify(me.productItem.extra_data.related_products)
      };
      this.$root.loadingQueueSize++;
      $.ajax(settings)
        .done(function(resp) {
          document.getElementById("app").style.display = "block";
          window.hideLoading();

          console.log(resp);
          if (resp.success == false) {
            me.$root.loadingQueueSize--;
            alert("An error occurs on server when getting products");
          } else {
            resp.data.forEach(elt => {
              //elt.unitPrice = elt.sale_price;
              //elt.image = elt.images[0].src;
              elt.extra_data = me.getMetaData(elt.meta_data);
            });
            console.log("products", resp.data);
            me.productItem.related_products = resp.data;
            me.relatedProductsLoaded = true;
            me.$root.loadingQueueSize--;
          }
        })
        .fail(function(resp) {
          me.$root.loadingQueueSize--;
          alert("An error occurs on server");
        });
    },
    getMetaData(data) {
      let result = {};
      data.forEach((item, index) => {
        if (item.key && item.value) {
          result[item.key] = item.value;
        }
      });
      return result;
    }
  }
};
</script>


<style lang="stylus">
.success-message {
  width: 380px;
  margin: 100px auto;
}

.success-message i {
  color: #5cb85c;
  text-align: center;
  width: 100%;
  font-size: 54px;
  padding-bottom: 10px;
}

.success-message p {
  color: #666;
  font-size: 16px;
  text-transform: capitalize;
  font-weight: normal;
}

@media (max-width: 480px) {
  .success-message {
    width: 100%;
    margin: 100px auto;
    padding: 0 30px;
  }
}

div.owl-carousel .item.hide {
  display: none !inmportant;
}
</style>
